import React, { type HTMLAttributes, forwardRef } from 'react'
import { twMerge } from 'tailwind-merge'
import { IconBadge } from '@/components/base/IconBadge'
import { Rings } from '@/components/composite/Rings'
import { retentionDialogHeaderTitleVariants } from './RetentionDialogHeader.variants'

export interface RetentionDialogHeaderProps extends HTMLAttributes<HTMLDivElement> {
  title: string
  subtitle?: string
  icon?: React.ReactNode
  accentColor?: 'none' | 'yellow' | 'green' | 'blue' | 'pink'
}

export const RetentionDialogHeader = forwardRef<HTMLDivElement, RetentionDialogHeaderProps>(
  ({ title, subtitle, icon, accentColor = 'none', className, ...props }, ref) => {
    return (
      <div
        className={twMerge('flex flex-col items-center justify-center pt-5', className)}
        ref={ref}
        {...props}
      >
        {icon ? (
          <div
            className={twMerge(
              'relative z-10 flex items-center justify-center',
              'w-[58px] h-[58px]',
              'rounded-full bg-glass-overlay-diagonal'
            )}
          >
            <IconBadge accentColor={accentColor} className="w-[58px] h-[58px]" rounded>
              {icon}
            </IconBadge>
            <Rings />
          </div>
        ) : null}

        <div className={retentionDialogHeaderTitleVariants({ accentColor })}>{title}</div>

        {subtitle ? (
          <div className="text-white font-formula text-center text-base font-bold">{subtitle}</div>
        ) : null}
      </div>
    )
  }
)

RetentionDialogHeader.displayName = 'RetentionDialogHeader'
